export const HOME = {
  emergentLink: "home-emergent-link",
};

export const NAV = {
  logo: "nav-logo",
  linkServices: "nav-link-services",
  linkAbout: "nav-link-about",
  linkGallery: "nav-link-gallery",
  linkContact: "nav-link-contact",
  bookBtn: "nav-book-btn",
};

export const HERO = {
  root: "hero-section",
  bookBtn: "hero-book-btn",
  servicesBtn: "hero-services-btn",
  ratingBadge: "hero-rating-badge",
};

export const SERVICES = {
  root: "services-section",
  card: (id) => `service-card-${id}`,
  bookServiceBtn: (id) => `book-service-${id}`,
};

export const ABOUT = { root: "about-section" };
export const GALLERY = { root: "gallery-section" };
export const TESTIMONIALS = { root: "testimonials-section" };
export const CONTACT = {
  root: "contact-section",
  whatsappBtn: "contact-whatsapp-btn",
  callBtn: "contact-call-btn",
};

export const BOOKING = {
  root: "booking-section",
  modal: "booking-modal",
  closeBtn: "booking-close-btn",
  stepper: "booking-stepper",
  serviceOption: (id) => `booking-service-${id}`,
  dateInput: "booking-date-input",
  timeSlot: (t) => `booking-time-${t.replace(":", "-")}`,
  nameInput: "booking-name-input",
  phoneInput: "booking-phone-input",
  notesInput: "booking-notes-input",
  nextBtn: "booking-next-btn",
  backBtn: "booking-back-btn",
  confirmBtn: "booking-confirm-btn",
  successRoot: "booking-success",
  successCode: "booking-success-code",
  successDoneBtn: "booking-success-done-btn",
  errorMsg: "booking-error-msg",
};
